<style scoped>

    table {
        font-size: 14px;
    }
</style>
<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <h3 v-if="patientid">Edit Patient Details</h3>
                <h3 v-else>Create New Patient</h3>
                <hr />
                <NewPatientForm v-model="Patient" :patientid="patientid"></NewPatientForm>
            </div>
        </div>
    </div>
</template>
<script>
    import $ from 'jquery';
    import FmdDal from "../../../scripts/FmdDal";
    import Formatter from "../../corecontrols/formatters/Formatter";
    import forminput from "../../corecontrols/forminput/forminput.scp.html";
    import PatientSearchBox from "../../appcontrols/PatientSearchBox/PatientSearchBox.scp.html"
    import NewPatientForm from "../../appcontrols/NewPatientForm/NewPatientForm.scp.html"

    export default {
        props: ['patientid'],
        components: {
            PatientSearchBox,
            forminput,
            NewPatientForm
        },
        data: function () {
            return {
                IsNew: false,
                IsNewPatient: true,
                Patient: null,
                searchFocus: false,
                FmdDal: undefined
            }
        },
        watch: {
            Patient(pt) {
                this.$router.push({ path: '/fmd/patient/' + pt.id})
            }
        },
        mounted() {
            this.FmdDal = new FmdDal(this.$root.CurrentUnitId, this.$root.UiSession)

        }
    }
</script>


// WEBPACK FOOTER //
// NewPatient.scp.html?c8d12420